import * as React from "react";

function SvgSoundClose(props) {
  return (
    <svg 
      width="1em" 
      height="1em" 
      viewBox="0 0 16 16" 
      {...props}
    >
      <path 
        d="M7.999 3H6.999V7V8H7.999H9.999V7H7.999V3ZM7.5 0C3.358 0 0 3.358 0 7.5C0 11.642 3.358 15 7.5 15C11.642 15 15 11.642 15 7.5C15 3.358 11.642 0 7.5 0ZM7.5 14C3.916 14 1 11.084 1 7.5C1 3.916 3.916 1 7.5 1C11.084 1 14 3.916 14 7.5C14 11.084 11.084 14 7.5 14Z" 
        fill="currentColor">
      </path>
    </svg>
  );
}

export default SvgSoundClose;
